import { Icon } from 'shared/iconpack'
import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'

import { useMemo } from 'react'

import { Link } from 'react-router-dom'

import { palette } from 'shared/config/styles/palette'

import { orderParams } from '../model/orderFilters'

import CreateOrderButton from './CreateOrderButton'

const EmptyOrdersTable = () => {
  const { getParam } = useAppSearchParams()

  const isResWithFilters = useMemo(() => {
    return orderParams.some((param) => (getParam(param) ? true : false))
  }, [getParam])

  return (
    <div className="flex flex-col gap-6 text-center items-center">
      <Icon
        name="notFound"
        width={70}
        height={70}
        color={palette.light_gray_15}
      />
      <div className="flex flex-col gap-3">
        <strong className="text-dark leading-7 text-xl">
          Заказов пока нет
        </strong>
        <p className="text-black/45 leading-6">
          {isResWithFilters
            ? 'Нет данных, соответствующих вашему запросу'
            : 'Здесь будут отображаться все заказы. Создайте первый заказ, чтобы начать работу с системой.'}
        </p>
      </div>
      {!isResWithFilters && (
        <div className="flex flex-col gap-6 items-center">
          <CreateOrderButton />
          <span className="text-black/45 leading-6">
            Нужна помощь?{' '}
            <Link
              className="text-blue"
              to="/dashboard/knowledge-place/"
            >
              Посмотрите обучающие материалы
            </Link>
          </span>
        </div>
      )}
    </div>
  )
}

export default EmptyOrdersTable
